/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BytesLike,
  BigNumberish,
  Overrides,
} from 'ethers'
import type { Provider, TransactionRequest } from '@ethersproject/providers'
import type { PromiseOrValue } from '../../common'
import type { ArtGobblers, ArtGobblersInterface } from '../../art-gobblers/ArtGobblers'

const _abi = [
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_merkleRoot',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: '_mintStart',
        type: 'uint256',
      },
      {
        internalType: 'contract Goo',
        name: '_goo',
        type: 'address',
      },
      {
        internalType: 'contract Pages',
        name: '_pages',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_team',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_community',
        type: 'address',
      },
      {
        internalType: 'contract RandProvider',
        name: '_randProvider',
        type: 'address',
      },
      {
        internalType: 'string',
        name: '_baseUri',
        type: 'string',
      },
      {
        internalType: 'string',
        name: '_unrevealedUri',
        type: 'string',
      },
      {
        internalType: 'bytes32',
        name: '_provenanceHash',
        type: 'bytes32',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'AlreadyClaimed',
    type: 'error',
  },
  {
    inputs: [],
    name: 'Cannibalism',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    name: 'CannotBurnLegendary',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'cost',
        type: 'uint256',
      },
    ],
    name: 'InsufficientGobblerAmount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidProof',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gobblersLeft',
        type: 'uint256',
      },
    ],
    name: 'LegendaryAuctionNotStarted',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MintStartPending',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NoRemainingLegendaryGobblers',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'totalRemainingToBeRevealed',
        type: 'uint256',
      },
    ],
    name: 'NotEnoughRemainingToBeRevealed',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NotRandProvider',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'OwnerMismatch',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'currentPrice',
        type: 'uint256',
      },
    ],
    name: 'PriceExceededMax',
    type: 'error',
  },
  {
    inputs: [],
    name: 'RequestTooEarly',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ReserveImbalance',
    type: 'error',
  },
  {
    inputs: [],
    name: 'RevealsPending',
    type: 'error',
  },
  {
    inputs: [],
    name: 'SeedPending',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'caller',
        type: 'address',
      },
    ],
    name: 'UnauthorizedCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ZeroToBeRevealed',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'nft',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'ArtGobbled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    name: 'GobblerClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    name: 'GobblerPurchased',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'numGobblers',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'lastRevealedId',
        type: 'uint256',
      },
    ],
    name: 'GobblersRevealed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'newGooBalance',
        type: 'uint256',
      },
    ],
    name: 'GooBalanceUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'burnedGobblerIds',
        type: 'uint256[]',
      },
    ],
    name: 'LegendaryGobblerMinted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'contract RandProvider',
        name: 'newRandProvider',
        type: 'address',
      },
    ],
    name: 'RandProviderUpgraded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'randomness',
        type: 'uint256',
      },
    ],
    name: 'RandomnessFulfilled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'toBeRevealed',
        type: 'uint256',
      },
    ],
    name: 'RandomnessRequested',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'lastMintedGobblerId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'numGobblersEach',
        type: 'uint256',
      },
    ],
    name: 'ReservedGobblersMinted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [],
    name: 'BASE_URI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'FIRST_LEGENDARY_GOBBLER_ID',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LEGENDARY_AUCTION_INTERVAL',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LEGENDARY_GOBBLER_INITIAL_START_PRICE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LEGENDARY_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_MINTABLE',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MAX_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'MINTLIST_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'PROVENANCE_HASH',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'RESERVED_SUPPLY',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'UNREVEALED_URI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: 'randomness',
        type: 'uint256',
      },
    ],
    name: 'acceptRandomSeed',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gooAmount',
        type: 'uint256',
      },
    ],
    name: 'addGoo',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'gooAmount',
        type: 'uint256',
      },
    ],
    name: 'burnGooForPages',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32[]',
        name: 'proof',
        type: 'bytes32[]',
      },
    ],
    name: 'claimGobbler',
    outputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'community',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'currentNonLegendaryId',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'getCopiesOfArtGobbledByGobbler',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'getGobblerData',
    outputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'uint64',
        name: 'idx',
        type: 'uint64',
      },
      {
        internalType: 'uint32',
        name: 'emissionMultiple',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    name: 'getGobblerEmissionMultiple',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'sold',
        type: 'int256',
      },
    ],
    name: 'getTargetSaleTime',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'getUserData',
    outputs: [
      {
        internalType: 'uint32',
        name: 'gobblersOwned',
        type: 'uint32',
      },
      {
        internalType: 'uint32',
        name: 'emissionMultiple',
        type: 'uint32',
      },
      {
        internalType: 'uint128',
        name: 'lastBalance',
        type: 'uint128',
      },
      {
        internalType: 'uint64',
        name: 'lastTimestamp',
        type: 'uint64',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'getUserEmissionMultiple',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'timeSinceStart',
        type: 'int256',
      },
      {
        internalType: 'uint256',
        name: 'sold',
        type: 'uint256',
      },
    ],
    name: 'getVRGDAPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'nft',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'isERC1155',
        type: 'bool',
      },
    ],
    name: 'gobble',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'gobblerPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'gobblerRevealsData',
    outputs: [
      {
        internalType: 'uint64',
        name: 'randomSeed',
        type: 'uint64',
      },
      {
        internalType: 'uint64',
        name: 'nextRevealTimestamp',
        type: 'uint64',
      },
      {
        internalType: 'uint64',
        name: 'lastRevealedId',
        type: 'uint64',
      },
      {
        internalType: 'uint56',
        name: 'toBeRevealed',
        type: 'uint56',
      },
      {
        internalType: 'bool',
        name: 'waitingForSeed',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'goo',
    outputs: [
      {
        internalType: 'contract Goo',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'gooBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'hasClaimedMintlistGobbler',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'legendaryGobblerAuctionData',
    outputs: [
      {
        internalType: 'uint128',
        name: 'startPrice',
        type: 'uint128',
      },
      {
        internalType: 'uint128',
        name: 'numSold',
        type: 'uint128',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'legendaryGobblerPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'merkleRoot',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'maxPrice',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'useVirtualBalance',
        type: 'bool',
      },
    ],
    name: 'mintFromGoo',
    outputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: 'gobblerIds',
        type: 'uint256[]',
      },
    ],
    name: 'mintLegendaryGobbler',
    outputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'numGobblersEach',
        type: 'uint256',
      },
    ],
    name: 'mintReservedGobblers',
    outputs: [
      {
        internalType: 'uint256',
        name: 'lastMintedGobblerId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'mintStart',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'numMintedForReserves',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'numMintedFromGoo',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    name: 'onERC1155BatchReceived',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    name: 'onERC1155Received',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pages',
    outputs: [
      {
        internalType: 'contract Pages',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'randProvider',
    outputs: [
      {
        internalType: 'contract RandProvider',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gooAmount',
        type: 'uint256',
      },
    ],
    name: 'removeGoo',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'requestRandomSeed',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'numGobblers',
        type: 'uint256',
      },
    ],
    name: 'revealGobblers',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'targetPrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'team',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gobblerId',
        type: 'uint256',
      },
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract RandProvider',
        name: 'newRandProvider',
        type: 'address',
      },
    ],
    name: 'upgradeRandProvider',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]

const _bytecode =
  '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'

type ArtGobblersConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: ArtGobblersConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1

export class ArtGobblers__factory extends ContractFactory {
  constructor(...args: ArtGobblersConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      super(_abi, _bytecode, args[0])
    }
  }

  override deploy(
    _merkleRoot: PromiseOrValue<BytesLike>,
    _mintStart: PromiseOrValue<BigNumberish>,
    _goo: PromiseOrValue<string>,
    _pages: PromiseOrValue<string>,
    _team: PromiseOrValue<string>,
    _community: PromiseOrValue<string>,
    _randProvider: PromiseOrValue<string>,
    _baseUri: PromiseOrValue<string>,
    _unrevealedUri: PromiseOrValue<string>,
    _provenanceHash: PromiseOrValue<BytesLike>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<ArtGobblers> {
    return super.deploy(
      _merkleRoot,
      _mintStart,
      _goo,
      _pages,
      _team,
      _community,
      _randProvider,
      _baseUri,
      _unrevealedUri,
      _provenanceHash,
      overrides || {},
    ) as Promise<ArtGobblers>
  }
  override getDeployTransaction(
    _merkleRoot: PromiseOrValue<BytesLike>,
    _mintStart: PromiseOrValue<BigNumberish>,
    _goo: PromiseOrValue<string>,
    _pages: PromiseOrValue<string>,
    _team: PromiseOrValue<string>,
    _community: PromiseOrValue<string>,
    _randProvider: PromiseOrValue<string>,
    _baseUri: PromiseOrValue<string>,
    _unrevealedUri: PromiseOrValue<string>,
    _provenanceHash: PromiseOrValue<BytesLike>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(
      _merkleRoot,
      _mintStart,
      _goo,
      _pages,
      _team,
      _community,
      _randProvider,
      _baseUri,
      _unrevealedUri,
      _provenanceHash,
      overrides || {},
    )
  }
  override attach(address: string): ArtGobblers {
    return super.attach(address) as ArtGobblers
  }
  override connect(signer: Signer): ArtGobblers__factory {
    return super.connect(signer) as ArtGobblers__factory
  }

  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): ArtGobblersInterface {
    return new utils.Interface(_abi) as ArtGobblersInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ArtGobblers {
    return new Contract(address, _abi, signerOrProvider) as ArtGobblers
  }
}
